import React, { useEffect, useState } from "react";
import { StepRenderProps } from "../../../interfaces/FlowInterfaces";
import { InvitationAcceptedStepValues } from "../../_interfaces/IAdminInvitationStepTypeValues";
import { IAdminInvitationFlowValues } from "../../_interfaces/IAdminInvitationFlowValues";
import { Container, createStyles, makeStyles, Paper, Theme } from "@material-ui/core";
import { observer } from "mobx-react";
import { useNavigateInternally } from "../../../../../components/Navigation/Hooks";
import { getAccountSettingsLink } from "../../../../../components/Navigation/Links";
import SuccessOrErrorMessage from "../../../../../components/Shared/SuccessOrErrorMessage";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        content: {
            marginTop: theme.spacing(2),
            padding: theme.spacing(4),
            display: 'inline-block',
            position: 'relative' // the loading spinner refers to this element
        },
        padder: {
            padding: theme.spacing(6),
            [theme.breakpoints.down('xs')]: {
                padding: theme.spacing(4)
            },
        }
    })
);

export const InvitationAcceptedStep: React.FC<
    StepRenderProps<InvitationAcceptedStepValues, IAdminInvitationFlowValues>
> = observer(({
    values,
    update,
    submit,
    canSubmit,
    validation,
    allValues
}) => {

    /********* React hooks *********/

    const classes = useStyles();
    const navigate = useNavigateInternally();

    const getFormId = () => {
        return `form-accepted-invitation-${Date.now()}-${Math.random()}`;
    }

    const [formId] = useState(() => getFormId());

    /********* Effects *********/

    useEffect(() => {
        update({
            password: "",
        });
    }, [])

    /********* Event Handlers *********/

    const onNavigateToProfile = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault(); // Prevent page reload
        event.stopPropagation();
        navigate(getAccountSettingsLink());
    }

    /********* Render *********/

    return (
        <Container>
            <Paper className={classes.content}>
                <div className={classes.padder}>
                    <form onSubmit={onNavigateToProfile} noValidate autoComplete="off" id={formId}>
                        <SuccessOrErrorMessage
                            title="Invitation accepted!"
                            details={`You're now an admin for ${allValues.organizationName}.`}
                            filled
                            success
                            ButtonProps={{ type: "submit", form: formId, children: "Navigate to Profile" }}
                        />
                    </form>
                </div>
            </Paper>
        </Container>
    );
});
